/**
 * Command utilities
 */

/**
 * Generate a unique command ID with cmd_ prefix for easy identification
 */
export function generateCommandId(): string {
  return `cmd_${crypto.randomUUID()}`
}
